import React, { useState, useEffect ,useRef} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LogoutModel from './LogoutModel';
import { flightSearchCredential,
    flightManifestBoardingCredential,
    flightTripBoardingCredential,
    selectedOriginDropdownCredential,
    selectedDestinationDropdownCredential,
    setflightLegKeyCredential,
    assistQueueCredential, moduleAndLoginDivDisabled
} from '../ReduxState';
import { Button, Modal } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import { useHistory, useLocation } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { fncFlightSearchForBoarding, fncStationsApi, fncLoadFlightManifestDataForBoarding, fncGetTripStatus, fncClosePendingFlight, fncOpenFlight, fncCloseFlight } from '../Utility/ApiCall.js';
import { flightsearchPageIconsMapping, monthNames, pageNavigationForBoardingModule, mapToProp, shortcutKeyForBoardingsPage, shortcutKeysBoarding, fncCheckIfTokenIsExpired, fncFocusElementDependsOnPathLocation } from '../Utility/CommonFun';
import '../Scss/_boarding.scss';
import FocusLock from "react-focus-lock";


// when i press shift+down  move inside table and first time i come to boarding row that time focus is going to searchinput
function FlightSearch() {
    const [focusedDivNo, setfocusedDivNo] = useState(0);    
    const searchFooterRef = useRef(null);   
    const Loadref=useRef(null);
    const [searchddisable, setsearchddisable] = useState(false); // Controls FocusLock
    const [searchFooterdisabled, setsearchFooterdisabled] = useState(true); // Controls FocusLock
    const [flightsdivfocus, setflightsdivfocus] = useState(false);
    const searchvalref = useRef(null); 
    const [Tabledisabled, setTableDisabled] = useState(true); // Controls FocusLock
    const tblrow = useRef([]);
    const [selectedValue, setSelectedValue] = useState("");
    const selectRef = useRef(null);
    const datePickerRef = useRef(null); // Create a ref for DatePicker
    const startDate = new Date();
    const [dateRangeStart, setdateRangeStart] = useState(startDate.setDate(startDate.getDate() - 1));
    const endDate = new Date();
    const [dateRangeEnd, setdateRangeEnd] = useState(endDate.setDate(endDate.getDate() + 1));


    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const sortByFlightList = {
        departure: 'Departure Time',
        arrival: 'Arrival Time',
        status: 'Status',
        flight: 'Flight'
    }
    const Location = useSelector(state => state.login.Location);
    const userRoleCode = useSelector(state => state.login.roleCode);
    const [triggerModal, settriggerModal] = useState(false);
    const ReduxDestinationDropdown = useSelector(state => state.selectedpassenger.DestinationDropdown);
    const ReduxOriginDropdown = useSelector(state => state.selectedpassenger.OriginDropdown);
    const flightList = useSelector(state => state.flightSearch.flightList);
    const [flights, setFlights] = useState(flightList && flightList.length === 0 ? [] : flightList)
    const [searchValue,setsearchValue] = useState(''); 
    const [isAdvance, setisAdvance] = useState(false);
    const [origin, setOrigin] = useState( Location === 'HDQ' ? 'DEL' : Location);
    const [destination, setDestination] = useState('');
    const [st_date, setDateToSearch] = useState(new Date());
    const [st_ErrorDate, setErrorDate] = useState('');
    const [st_ErrorOrigin, setErrorOrigin] = useState('');
    const [flightnum, setFlightNum] = useState('');
    const [opsuffix, setOPSuffix] = useState('');
    const [selectedRow, setSelectedRow] = useState(-1);
    const [isLoadFlightAvailable, setIsLoadFlightAvailable] = useState(true);
    const [open, setOpen] = useState(true);
    const [close, setClose] = useState(true);
    const [closePending, setClosePending] = useState(true);
    const [sortHeading, setSortHeading] = useState(sortByFlightList['departure']);
    const flightManifest = useSelector(state => state.flightSearch.flightManifestBoarding);
    const flightTripBoarding = useSelector(state => state.flightSearch.flightTripBoarding);
    const assistErrorQueue = useSelector(state => state.flightSearch.assistQueue);
    const selectedLeg = useSelector(state => state.flightSearch.selectedFlight);
    const IsModulAndLoginDivDisabled = useSelector(state => state.login.IsModulAndLoginDivDisabled);
    
    // console.log('isAdvance------', isAdvance, selectedRow);
    const notify = (e) =>
    toast.error(e, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });

    const notifySuccess = (e, close = 5000) =>
        toast.success(e, {
            position: "top-right",
            autoClose: close,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });

    // useEffect(() => {
    //     // console.log('document.getElementById("loadFlight")', document.getElementById("loadFlight"), document.getElementById("loadFlight").disabled);
    //     document.addEventListener("keyup", function (event) {        
    //         if (event.key === 'Enter') {
    //             if (selectedRow !== -1 
    //                 && document.getElementById("loadFlight") && document.getElementById("loadFlight").disabled == false) {
    //                 document.getElementById("loadFlight").click();
    //             }
    //             if (document.getElementById('searchBar') && searchValue !== '') {
    //                 document.getElementById("searchBar").click();
    //             }
    //         }
    //     });
    // }, [selectedRow, searchValue]);

    useEffect(() => {
        const handleKeyUp = (event) => {
          if (event.key === 'Enter') {
            const activeElement = document.activeElement;
            const loadFlightButton = document.getElementById("loadFlight");
            if (activeElement === loadFlightButton) {
              return;
            }
            if (document.getElementById('searchBar') && searchValue !== '') {
              document.getElementById("searchBar").click();
            } else if (document.getElementById("loadFlight") && !document.getElementById("loadFlight").disabled) {
              document.getElementById("loadFlight").click();
            }
          }
        };
      
        document.addEventListener("keyup", handleKeyUp);
      
        return () => {
          document.removeEventListener("keyup", handleKeyUp);
        };
      }, [searchValue]);

    useEffect(() => {
        if (selectedLeg && flightManifest) {
            document.addEventListener("keydown", shortcutKeyHandler);
        }

        // cleanup this listener
        return () => {
            document.removeEventListener('keydown', shortcutKeyHandler);
        };
    }, [selectedLeg, selectedRow, flightManifest]);

    // useEffect(() => {
    //     let keysPressed = {};
    //     debugger
    //     // if (selectedRow !== -1) {
    //         document.addEventListener('keydown', (event) => {
    //             keysPressed[event.key] = true;
    //         //  console.log('----------------', event.key);
    //             // if (keysPressed['Control'] && event.key == 'a') {
    //             //     alert(event.key);
    //             // }
    //             if (keysPressed['Control'] && keysPressed['Alt'] && event.key == 'ø') { //open
    //                 // alert(event.key);
    //                 debugger
    //                 if (!open && selectedRow !== -1) {
    //                     document.getElementById("flightOpen").click();
    //                 }
    //             }
    //             if (keysPressed['Control'] && keysPressed['Alt'] && event.key == 'π') { //close pending
    //                 // alert(event.key);
    //                 if (!closePending && selectedRow !== -1) {
    //                     document.getElementById("flightClosePending").click();
    //                 }
    //             }
    //             if (keysPressed['Control'] && keysPressed['Alt'] && event.key == 'ç') { //close
    //                 // alert(event.key);
    //                 debugger
    //                 if (!close && selectedRow !== -1) {
    //                     document.getElementById("flightClose").click();
    //                 }
    //             }
    //         });
    //         //  document.addEventListener('keyup', (event) => {
    //         //     delete keysPressed[event.key];
    //         //  });
    //         // cleanup this listener
    //         return () => {
    //             document.removeEventListener('keydown', (e) => {
    //                 delete keysPressed[e.key];
    //             });
    //         };
    //         //  console.log('==========', keysPressed);
    //     // }
    // },[selectedRow])

    const shortcutKeyHandler = (e) => { 
        // debugger
        if (e.key && shortcutKeysBoarding.includes(e.key)) {
            const path = shortcutKeyForBoardingsPage(location.pathname,e);
            if (path) {
                history.push('/' + path);    
            } 
        }
    }

    useEffect(() => {
        debugger
        if (flightManifest || flightTripBoarding || assistErrorQueue.length) {
            dispatch(flightManifestBoardingCredential(
                {
                    type: '',
                    flightManifestBoarding: null
                }
            ))
            dispatch(flightTripBoardingCredential(
                {
                    type: '',
                    flightTripBoarding: null
                }
            ))
            dispatch(assistQueueCredential(
                {
                    type: "",
                    assistQueue: [],
                }
            ))
        }

        if (ReduxDestinationDropdown.length === 0 || ReduxOriginDropdown.length === 0) {
            fncStationsApi()
            .then((returnVal) => {
                if (returnVal.status == "401" && returnVal.data == "") {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        //     notify(returnVal.statusText);
                        settriggerModal(true);
                }
                else {
                    if (returnVal.data.isError == false) {

                        dispatch(selectedOriginDropdownCredential(
                                {
                                        type: "",
                                        OriginDropdown: returnVal.data.stations,

                                }))
                        dispatch(selectedDestinationDropdownCredential(
                                {
                                        type: "",
                                        DestinationDropdown: returnVal.data.stations
                                }))
                    }
                    else {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                        if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                settriggerModal(true);
                        } else {
                            notify(returnVal.data.errorDetail.errorMessage);
                        } 
                    }
                }
            })
            .catch(err => console.log("Axios err: ", err));
        }
    },[]);

    useEffect(() => {
        debugger
        if(flights && flights.length === 0) {
            const apiData = {
                beginDate: new Date(),
                originStations: Location === 'HDQ' ? ['DEL'] : [Location],
                destinationStations: [""],
                identifier: "",
                carrierCode: process.env.REACT_APP_AirlineCode
            }
            fncFlightSearchForBoarding(apiData)
            .then((returnVal) => {
                if (returnVal.status == "401" && returnVal.data == "") {
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    //notify(returnVal.statusText);
                    settriggerModal(true);
                }
                else {
                    if (returnVal.data.isError == false) {
                        
                        dispatch(flightSearchCredential(
                        {
                            type: "",
                            flightList: returnVal.data.flightData,
                        }))
                        setFlights(returnVal.data.flightData);
                    }
                    else {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                settriggerModal(true);
                        } else {
                        notify(returnVal.data.errorDetail.errorMessage);
                        } 
                    }
                }
                document.getElementById("showAndHideSpinner").style.display = "none";
            })
            .catch(err => console.log("Axios err: ", err));
        }
    }, []);

    const formatAMPM = (date) => {
        date = new Date(date);
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    };

    const getStatusText = (status) => {
        let statusText;
        switch(status)
        {
            case '0':
                statusText = 'Open';
                break;
            case '1': 
                statusText = 'Closed';
                break;
            case '2': 
                statusText = 'Cancelled';
                break;
            case '3': 
                statusText = 'Suspended';
                break;
            case '5': 
                statusText = 'ClosedPending';
                break;
            case '6': 
                statusText = 'BlockAllActivities';
                break;
            case '7': 
                statusText = 'Mishap';
                break;
            default:
                statusText = '';
                break;
        }
        return statusText;
    }

    const sortBy = (sortBy) => {
        let flightListBySorting = [...flights];
        switch(sortBy)
        {
            case 'departure':
                flightListBySorting.sort(function (a, b) {
                    return new Date(a.designator.departure) - new Date(b.designator.departure);
                });
                break;
            case 'arrival': 
                flightListBySorting.sort(function (a, b) {
                    return new Date(a.designator.arrival) - new Date(b.designator.arrival);
                });
                break;
            case 'status': 
                flightListBySorting.sort(function (a, b) {
                    return (a.legDetails.status - b.legDetails.status);
                });
                break;
            case 'flight': 
                flightListBySorting.sort(function (a, b) {
                    return (a.identifier.identifier - b.identifier.identifier);
                });
                break;
            default:
                flightListBySorting = [...flightList];
                break;
        }
        setSortHeading(sortByFlightList[sortBy]);
        setFlights(flightListBySorting);
    };

    const fncSearchButtonIconClick = () => {
        // debugger
        const flightArray = [...flights];
        const filteredFlightList = [];
        const objecttTolook = ['designator', 'identifier'];
        if (searchValue !== '') {
            flightArray.forEach((obj) => {
                const keys = Object.keys(obj);
                keys.forEach((key, index) => {
                    if(objecttTolook.includes(key)) {
                        const innerObject = obj[key];
                        const innerKeys = Object.keys(innerObject);
                        innerKeys.forEach((k,i) => {
                            if(innerObject[k]!==null && innerObject[k].toLowerCase().indexOf(searchValue.toLowerCase()) > -1) {
                                filteredFlightList.push(obj);
                            }
                        })
                    } 
                });
            });
            // console.log('Result: ', filteredFlightList);
            setFlights(filteredFlightList);
        } else {
            setFlights(flightList);
        }
    }

    const fncOnchange = (e) => {
        const { value, id } = e.target;
        if (id === 'SEARCHVALUE') {
            if (value === '') {
                setsearchValue('');
                setFlights(flightList);
            } else {
                setsearchValue(value);
            }
            
        }
        if (id === "fnumber") {
            if (value !== '') {
                if (/^[0-9]+$/.test(value)) {
                    if (value.length <= 5) {
                        setFlightNum(value);
                    }
                }
            }
            else {
                setFlightNum(value);
            }
        }
        if (id === "opSuffix") {
            setOPSuffix(value);
        }
    }

    const fncAdvanceSearch = (e) => {
        // debugger
        // console.log('fncAdvanceSearch', e.target.checked);
        setisAdvance(e.target.checked);
    }

    const fncOriginChange = (e) => {
        var originID = e.target.value;
        if (originID.toUpperCase() == "Select a Origin".toUpperCase()) {
                originID = "";
        }
        setErrorOrigin("");
        setOrigin(originID);
    }

    const fncDestinationChange = (e) => {
                
        // console.log(e);
        var DestinationValue = e.target.value;
        var DestinationID = e.target.id;
        if (DestinationValue.toUpperCase() == "Select a Destination".toUpperCase()) {
                DestinationValue = "";
        }
        setDestination(DestinationValue);
    }

    const handleDateChange = (e) => {
        // console.log(e);
        setErrorDate('');
        setDateToSearch(e);
    }

    const handleDateSelect = (e) => {
        setErrorDate('');
        setDateToSearch(e);
    }

    const fncSearchButtonClick = (from) => {
        // console.log('from', from);
        // console.log('=---', st_date, origin, destination, flightnum);
        debugger
        if(isAdvance) {
            const apiData = {
                beginDate: st_date,
                originStations: [origin],
                destinationStations: [destination],
                identifier: flightnum,
                carrierCode: process.env.REACT_APP_AirlineCode
            }
            fncFlightSearchForBoarding(apiData)
            .then((returnVal) => {
                if (returnVal.status == "401" && returnVal.data == "") {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        //notify(returnVal.statusText);
                        settriggerModal(true);
                }
                else {
                    if (returnVal.data.isError == false) {
                        
                        dispatch(flightSearchCredential(
                        {
                            type: "",
                            flightList: returnVal.data.flightData,
                        }))
                        setFlights(returnVal.data.flightData);
                        setisAdvance(false);
                    }
                    else {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                settriggerModal(true);
                        } else {
                        notify(returnVal.data.errorDetail.errorMessage);
                        } 
                    }
                }
                document.getElementById("showAndHideSpinner").style.display = "none";
            })
            .catch(err => console.log("Axios err: ", err));
        }
    }

    const loadFlightData = async () => {
        const selectedFlight = selectedRow !== -1 ? flights.find((item, index) => index === selectedRow) : null;
        // console.log('selectedlegKey', selectedFlight.legKey);
        if (selectedFlight && selectedFlight.legKey) {
            try {
                const manifestData = await fncLoadFlightManifestDataForBoarding(selectedFlight.legKey);
                const tripData = await fncGetTripStatus(selectedFlight.legKey);
                if ((manifestData.status == "401" && manifestData.data == "") ||  (tripData.status == "401" && tripData.data == "")) {
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    //notify(returnVal.statusText);
                    settriggerModal(true);
                } else {
                    if (!manifestData.data.isError) {
                        const { passengerList } = manifestData.data.data;
                        const mapAndCountByRecordLocator = mapToProp(passengerList, 'recordLocator');
                        passengerList.length && passengerList.forEach(pax => {
                            pax.isChecked = false;
                            pax.isSelectedForSeatAssign = false;
                            pax.recordLocatorCount = mapAndCountByRecordLocator[pax.recordLocator] === 1 ? '' : `1/${mapAndCountByRecordLocator[pax.recordLocator]}`;
                        });
                        dispatch(flightManifestBoardingCredential(
                            {
                                type: '',
                                flightManifestBoarding: manifestData.data.data
                            }
                        ))

                    } else {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        notify(manifestData.data.errorDetail.errorMessage);
                    }

                    if (!tripData.data.isError) {
                        const { destinationDetails, operationDetails, originDetails, irop } = tripData.data;
                        dispatch(flightTripBoardingCredential(
                            {
                                type: '',
                                flightTripBoarding: { destinationDetails, operationDetails, originDetails, irop }
                            }
                        ))
                    } else {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        notify(tripData.data.errorDetail.errorMessage);
                    }
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    dispatch(setflightLegKeyCredential({
                        type: '',
                        selectedFlight: selectedFlight.legKey
                    }));
                    const navPage = pageNavigationForBoardingModule('FlightSearch');
                    history.push("/"+navPage);          
                }
            } catch (e) {
                console.log('error in loading flight data', e);
                document.getElementById("showAndHideSpinner").style.display = "none";
                notify(e.message);
            }
        }
    }

    const callFlightSearch = (apiRequest) => {
        fncFlightSearchForBoarding(apiRequest)
        .then((returnVal) => {
            if (returnVal.status == "401" && returnVal.data == "") {
                document.getElementById("showAndHideSpinner").style.display = "none";
                //notify(returnVal.statusText);
                settriggerModal(true);
            }
            else {
                if (returnVal.data.isError == false) {
                    
                    dispatch(flightSearchCredential(
                    {
                        type: "",
                        flightList: returnVal.data.flightData,
                    }))
                    setFlights(returnVal.data.flightData);
                    setOpen(true);
                    setClose(true);
                    setClosePending(true);
                }
                else {
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                            settriggerModal(true);
                    } else {
                    notify(returnVal.data.errorDetail.errorMessage);
                    }
                }
            }
            document.getElementById("showAndHideSpinner").style.display = "none";
        })
        .catch(err => console.log("Axios err: ", err));
    }

    const fncFlightOptions = (option) => {
        const selectedFlight = selectedRow !== -1 ? flights.find((item, index) => index === selectedRow) : null;
        let apiData = {
            beginDate: new Date(),
            originStations: Location === 'HDQ' ? ['DEL'] : [Location],
            destinationStations: [""],
            identifier: "",
            carrierCode: process.env.REACT_APP_AirlineCode
        }

        if (st_date || origin || destination || flightnum) {
            apiData = {
                beginDate: st_date,
                originStations: origin ? [origin] : Location === 'HDQ' ? ['DEL'] : [Location],
                destinationStations: destination ? [destination] : [""],
                identifier: flightnum ? flightnum : "",
                carrierCode: process.env.REACT_APP_AirlineCode
            }
        }

        if (selectedFlight && selectedFlight.legKey) {
            if (option === 'ClosePending') {
                fncClosePendingFlight(selectedFlight.legKey)
                .then((returnVal) => {
                    if (returnVal.status == "401" && returnVal.data == "") {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        //notify(returnVal.statusText);
                        settriggerModal(true);
                    }
                    else {
                        if (returnVal.data.isError == false) {
                            // notifySuccess('Close pending done');
                            callFlightSearch(apiData);
                        }
                        else {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                    settriggerModal(true);
                            } else {
                            notify(returnVal.data.errorDetail.errorMessage);
                            }
                        }
                    }
                    document.getElementById("showAndHideSpinner").style.display = "none";
                })
                .catch(err => console.log("Axios err: ", err));
            }
            if (option === 'Close') {
                fncCloseFlight(selectedFlight.legKey)
                .then((returnVal) => {
                    if (returnVal.status == "401" && returnVal.data == "") {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        //notify(returnVal.statusText);
                        settriggerModal(true);
                    }
                    else {
                        if (returnVal.data.isError == false) {
                            // notifySuccess('Close done');
                            callFlightSearch(apiData);
                        }
                        else {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                    settriggerModal(true);
                            } else {
                            notify(returnVal.data.errorDetail.errorMessage);
                            }
                        }
                    }
                    document.getElementById("showAndHideSpinner").style.display = "none";
                })
                .catch(err => console.log("Axios err: ", err));
            }
            if (option === 'Open') {
                fncOpenFlight(selectedFlight.legKey)
                .then((returnVal) => {
                    if (returnVal.status == "401" && returnVal.data == "") {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        //notify(returnVal.statusText);
                        settriggerModal(true);
                    }
                    else {
                        if (returnVal.data.isError == false) {
                            // notifySuccess('Open done');
                            callFlightSearch(apiData);
                        }
                        else {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                    settriggerModal(true);
                            } else {
                            notify(returnVal.data.errorDetail.errorMessage);
                            }
                        }
                    }
                    document.getElementById("showAndHideSpinner").style.display = "none";
                })
                .catch(err => console.log("Axios err: ", err));
            }
            setSelectedRow(-1);
        }
    }

    const selectRow = (index) => {
        debugger
        setsearchddisable(true);
        if (selectedRow === index) {
            setOpen(true);
            setClosePending(true);
            setClose(true);
            setSelectedRow(-1);
            setIsLoadFlightAvailable(true);
        } else {
            const selectedFlight = index !== -1 ? flights.find((item, i) => i === index) : null;
            if (selectedFlight && selectedFlight.legKey) {
                const flightStatus = getStatusText(selectedFlight.legDetails.status);
                console.log('flightStatus',flightStatus );
                if (flightStatus !== 'Cancelled') {
                    setIsLoadFlightAvailable(false);
                } else {
                    setIsLoadFlightAvailable(true);
                }
                // console.log('flightStatus', flightStatus);
                if (flightStatus === 'Boarding') {
                    setClose(false);
                    setClosePending(false);
                }
                else if (flightStatus === 'Closed') {
                    setOpen(false);
                    setClosePending(false);
                }
                else if (flightStatus === 'ClosedPending' || flightStatus === 'BlockAllActivities') {
                    setClose(false);
                    setOpen(false);
                } else {
                    setOpen(true);
                    setClose(true);
                    setClosePending(true);
                }
            }
            setSelectedRow(index);
        } 
    }


// update
    useEffect(() => {
        if (isAdvance ) {
                if (datePickerRef.current) {
                    datePickerRef.current.setFocus(); // React DatePicker has a setFocus() method
                }
        }
    }, [isAdvance]);

    // const handleDropdownItemKeyDown = (e, option) => {
             
    //     if (e.key === "Enter") {
    //         e.preventDefault();
    //         sortBy(option); // Trigger sorting
    //         closeDropdown();
    //         if(flights.length > 0){
    //             let firstbtn=flights.findIndex(item => item.legDetails.status === "0");
    //           if( tblrow.current){
    //             tblrow.current[firstbtn].focus();
    //           }
    //         }
    //     }
     
    //     // else if (e.key === "Escape") {
    //     //   document.getElementById("profile")?.focus();
    //     // }
    //   };

      
const   handlefocus=() => {
    const amountInput = document.getElementById("SEARCHVALUE");
    if (amountInput) {
      amountInput.focus();
    }
}
const handleClick = () => {
    if (selectRef.current) {
        selectRef.current.focus(); // Ensure focus on select when clicked
    }
};

const handleChange = (e) => {
    const selectedOption = e.target.value;
    setSelectedValue(selectedOption);
    sortBy(selectedOption); // Call sorting function
};


useEffect(() => {
    const handleKeyDown = (event) => {
        if (event.altKey && event.key.toLowerCase() === 'c') {
            if(!IsModulAndLoginDivDisabled){
                dispatch(moduleAndLoginDivDisabled({
                    type: "MODULE_AND_LOGINDIV_DISABLED",
                    IsModulAndLoginDivDisabled: true
                }));
                setsearchddisable(false);
                fncFocusElementDependsOnPathLocation(location.pathname,searchvalref.current);
            }else if (IsModulAndLoginDivDisabled) {
                setsearchddisable(true);
                        const headingDiv = document.querySelector(".modulebtn");            
                        if (headingDiv) {                  
                            headingDiv.focus();
                            dispatch(moduleAndLoginDivDisabled({
                                    type: "MODULE_AND_LOGINDIV_DISABLED",
                                    IsModulAndLoginDivDisabled: false
                                }));
                        }
            }
        }
        if(!isAdvance){
        if (!flights.length) return;
        let newIndex = selectedRow;
        if (event.shiftKey && event.key === "ArrowUp") {
            event.preventDefault(); // Prevent scrolling
            setsearchFooterdisabled(true);
            setflightsdivfocus(false);
            setTableDisabled(true);
            setsearchddisable(false);
            searchvalref.current?.focus(); // Move focus back to search input
            return;
        }
    
    else    if (event.shiftKey && event.key === "ArrowDown") {
            event.preventDefault(); 
            if(!flightsdivfocus) {
                // First Shift + Arrow Down press moves focus to the table
                setflightsdivfocus(true);
                setSelectedRow(0);
                setTableDisabled(false);    
            }   
             else
             if (flightsdivfocus) {
                // If inside the table, move focus to the Load button in the footer
                // setflightsdivfocus(false);
                setTableDisabled(true);
                setsearchddisable(true);
                Loadref.current?.focus();
                setsearchFooterdisabled(false);
            }
        } 
        // If Load button is focused, move to Search Footer on the next Shift + Arrow Down
        // else if (event.shiftKey && event.key === "ArrowDown" && document.activeElement === Loadref.current) {
        //     event.preventDefault();
        //     searchFooterRef.current?.focus();
        // }
     else   if (event.key === "ArrowDown") {
            newIndex = Math.min(selectedRow + 1, flights.length - 1);
            setSelectedRow(newIndex);
            tblrow.current[newIndex]?.focus(); // Ensure row focus
            selectRow(newIndex);

        } else if (event.key === "ArrowUp") {
            newIndex = Math.max(selectedRow - 1, 0);
            setSelectedRow(newIndex);
            tblrow.current[newIndex]?.focus(); // Ensure row focus
            selectRow(newIndex);
        }

        if (newIndex !== selectedRow) {
            setSelectedRow(newIndex);
            setTimeout(() => {
                tblrow.current[newIndex]?.focus(); // Ensure row focus
                selectRow(newIndex);
            }, 0);
        }
    };
    }
    document.addEventListener("keydown", handleKeyDown);
    return () => {
        document.removeEventListener("keydown", handleKeyDown);
    };
}, [selectedRow, flightsdivfocus, flights, isAdvance, IsModulAndLoginDivDisabled]);

// Ensure the selected row gets focus when it changes
useEffect(() => {
    if (tblrow.current[selectedRow]) {
        tblrow.current[selectedRow].focus();
    }
}, [selectedRow]);
useEffect(() => {
    setTableDisabled(true);
    console.log(Tabledisabled,"Tabledisabled")
    if(!isLoadFlightAvailable){
        if (Loadref.current) {
            Loadref.current.focus();
        }
    }else{
        // setTableDisabled(false);
    }
}, [isLoadFlightAvailable]);
const handleBlur = (e) => {
    if (!selectedDate) {
        e.preventDefault(); // Prevent blur if no date is selected
        datePickerRef.current?.setOpen(true); // Keep date picker open
    }
};

const handleKeyDown = (e) => {};

    return (
        <div>
            <LogoutModel trigger={triggerModal}> </LogoutModel>
            <div class="full-container">
            <div class="card mt-3 pt-3 boarding">
            <FocusLock disabled={isAdvance ? true : searchddisable}>
                <div class="search-outer primary">
                    <div class="search">
                        <input class="font-md focusClass input-box1" type="text" ref={searchvalref} id="SEARCHVALUE" name="search" value={searchValue} onChange={(e) => { fncOnchange(e) }} placeholder="Type Search Terms" />
                        <div class="icon">
                            <img src="newImages/search-dark.svg" id="searchBar" alt="icon-search" onClick={() => { fncSearchButtonIconClick() }} />
                        </div>
                    </div>
                    <div class="search-checkbox justify-content-between">
                    <div class="font-md">
                                <input class="form-check-input  checkbox-input" tabindex={0} name="flighSearchBooarding" type="checkbox" id="advanceSearchCheck" onChange={(e) => { fncAdvanceSearch(e) }} checked={isAdvance} />
                                <label class="form-check-label font-md white-text" for='advanceSearchCheck'>
                                    Advance Search
                            </label>
                            </div>
                        <div class="boardingSort">
                            <p class="font-sm bold white-text mb-1">Sort By </p>
                            <div className="dropdown-selector">
            <select
                id="dropdown"
                className="form-select"
                value={selectedValue}
                onChange={handleChange}
                onClick={handleClick}
                ref={selectRef}
            >
                <option value="" disabled>{sortHeading}</option>
                <option value="departure">Departure Time</option>
                <option value="arrival">Arrival Time</option>
                <option value="status">Status</option>
                <option value="flight">Flight</option>
            </select>
        </div>
                        </div>   
                    </div>
                    
                </div>
                </FocusLock>

                {
                    isAdvance ? 
                    <div class="boardingAdvanceSearch" id="advanceSearchContent" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                        <h4 class="dark-text bold font-xxl mb-3">Advance Search</h4>
                        <div class="row">
                            <div class="col-lg-4 col-md-6 mb-4 ">
                                {/* <div class="form-floating date ">
                                    <input type="text" class="form-control" id="dateInput" placeholder="DD/MM/YYYY" />
                                    <span class="icon">
                                        <img class="icon-24" src="./assets/images/icon-date.svg"/>
                                    </span>
                                    <label for="dateInput">Date</label>
                                </div> */}
                                <div class="form-floating date ">
                                <DatePicker
                                                ref={datePickerRef} // Attach ref here

                                                autocomplete="new-date"
                                                name="date"
                                                className="form-control focusClass"
                                                dateFormat="dd-MM-yyyy"
                                                selected={st_date}
                                                // minDate={dateRangeStart}
                                                // maxDate={dateRangeEnd}
                                                onSelect={(e) => { handleDateSelect(e) }}
                                                onChange={(e) => { handleDateChange(e) }}
                                                onBlur={() =>handleBlur} // Close on clicking outside
                                                />
                                    <span class="icon">
                                    <img class="icon-24" src="newImages/icon-date.svg"/>
                                    </span>
                                    <p className="clsErrorDate" >{st_ErrorDate}</p>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 mb-4 ">
                                <div class="departure">
                                    <div class="icon">
                                        <img src="newImages/departure.svg" alt="departure" />
                                    </div>
                                    <div class="form-floating">
                                        {/* <select class="form-select" id="origin" aria-label="origin">
                                            <option>Select</option>
                                            <option value="1">Delhi</option>
                                            <option value="2">Bangalore</option>
                                            <option value="3">Mumbai</option>
                                        </select> */}
                                        <select class="form-select focusClass" value={origin} onChange={e => fncOriginChange(e)} id="origin" aria-label="origin">
                                            <option id="0">Select a Origin</option>
                                            {
                                                ReduxOriginDropdown.length === 0 ? '' : ReduxOriginDropdown.map((dest, i) =>
                                                    <option id={dest.stationCode}>{dest.stationCode}</option>
                                                )
                                            }
                                        </select>
                                        <label>Origin</label>
                                    </div>
                                    <p className="clsError" >{st_ErrorOrigin}</p>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 mb-4">
                                <div class="arrival">
                                    <div class="icon">
                                        <img src="newImages/arrival.svg" alt="arrival" />
                                    </div>
                                    <div class="form-floating ">
                                        {/* <select class="form-select" id="destination" aria-label="destination">
                                            <option>Select</option>
                                            <option value="1">Delhi</option>
                                            <option value="2">Bangalore</option>
                                            <option value="3">Mumbai</option>
                                        </select> */}
                                        <select class="form-select focusClass" value={destination} onChange={e => fncDestinationChange(e)} id="destination" aria-label="destination">
                                            <option id="0">Select a Destination</option>
                                            {
                                                ReduxDestinationDropdown.length === 0 ? '' : ReduxDestinationDropdown.map((dest, i) =>
                                                    <option id={dest.stationCode}>{dest.stationCode}</option>
                                                )
                                            }
                                        </select>
                                        <label for="destination">Destination</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-4 col-md-6 mb-4 ">
                                <div class="form-floating  ">
                                    {/* <input type="text" class="form-control" id="carrier" placeholder="Carrier" /> */}
                                    <select class="form-select" tabIndex={-1}>
                                        <option id={process.env.REACT_APP_AirlineCode}>{process.env.REACT_APP_AirlineCode}</option>
                                    </select>
                                    <label for="carrier">Carrier</label>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 mb-4 ">
                                <div class="form-floating  ">
                                    <input type="text" class="form-control focusClass" id="fnumber" onChange={(e) => { fncOnchange(e) }} value={flightnum} placeholder="Flight Number" />
                                    <label for="fnumber">Flight Number</label>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 mb-4 ">
                                <div class="form-floating  ">
                                    <input type="text" class="form-control focusClass" id="opSuffix" placeholder="Op Suffix" onChange={(e) => { fncOnchange(e) }} value={opsuffix} />
                                    <label for="opSuffix">Op Suffix</label>
                                </div>
                            </div>
                        </div>
                    
                        <div class="d-flex justify-content-end mt-3 ">
                            <button id="searchBooking"  onClick={() => { fncSearchButtonClick("ONPOPUP") }} class="btn btn-primary btn-animation me-4 SerachBtn">
                                <span class="px-4">Search</span>
                            </button>
                            <button id="cancelAdvanceSearch" onBlur={handlefocus}  onClick={() => setisAdvance(false)} class="btn btn-primary btn-animation SerachBtn">
                                <span class="px-4">Cancel</span>
                            </button>
                        </div>
                    </div> : null
                }
                <div class="searchContent">
                <h4 class="dark-text bold font-xxl mb-3">Search</h4> 
                <div class="searchTable">
                <FocusLock disabled={Tabledisabled}>

                    <table>
                        <thead>
                            <tr>
                                <th></th>
                                <th>Flight</th>
                                <th>Route</th>
                                <th>Date</th>
                                <th>Departure/Arrival</th>
                                <th>Status</th>
                            
                            </tr>
                        </thead>
                        {
                            flights.length ?
                            flights && flights.length && flights.map((item, i) =>
                                <tbody key={i}>
                                <tr key={i} 
                                tabindex={0}
                                style={selectedRow === i ? {'backgroundColor': '#F6C1B1'} : {'': ''}}
                                ref={(el) => (tblrow.current[i] = el)}  
                                onClick={() => { selectRow(i) }}
                                onKeyDown={handleKeyDown} 
                                >
                                    <td>{ i+1 }</td>
                                    <td>
                                        <div class="flightContent">
                                            <img class="me-2" src={flightsearchPageIconsMapping[item.legDetails.status]} alt={item.legDetails.status} />
                                            {`${item.identifier.carrierCode} ${item.identifier.identifier}`}
                                        </div>
                                    </td>
                                    <td>{item.designator.origin} to {item.designator.destination}</td>
                                    <td>{("0"+new Date(item.designator.departure).getDate()).slice(-2)+" "+monthNames[new Date(item.designator.departure).getMonth()]} </td>
                                    <td>{formatAMPM(item.designator.departure)} - {formatAMPM(item.designator.arrival)}</td>
                                    <td class={item.legDetails.status === '0' ? 'boarding' : 'Cancelled'}>
                                        {getStatusText(item.legDetails.status)}
                                    </td>
                                </tr>
                                </tbody>
                            ) : 
                            <tr className="noresultErrormessage">No result found. Please refine your search terms</tr>
                        }
                    </table>
                    </FocusLock>
                </div> 
                <FocusLock disabled={searchFooterdisabled}>
                <div class={`searchFooter OrangeShadow ${isAdvance ? 'hide-div' : ''}`} tabIndex={-1} ref={searchFooterRef}>
                    <div class="flight-status">
                        <div class="heading">
                            <h4 class="dark-text bold font-lg">
                                FLIGHT STATUS
                            </h4>
                            <h4 class="dark-text bold font-md">
                                {/* Ctrl+Alt+ */}
                            </h4>
                        </div>
                        {
                            userRoleCode === 'APT' ?
                            null :
                            <div class="cmd">
                                <a class="btn btn-outline-primary dark-text font-sm me-3" id='flightOpen' disabled={open} onClick={() => { !open && fncFlightOptions("Open") }}>Open  </a> 
                                {/* (O) */}
                                <a class="btn btn-outline-primary dark-text font-sm me-3" id='flightClosePending' disabled={closePending} onClick={() => { !closePending && fncFlightOptions("ClosePending") }}>Close Pending</a>
                                {/* (P) */}
                                <a class="btn btn-outline-primary dark-text font-sm me-3" id='flightClose' disabled={close} onClick={() => { !close && fncFlightOptions("Close") }}>Close </a>
                                {/* (C) */}
                            </div>
                        }
                    </div>
                    <button class="btn btn-primary btn-animation SerachBtn OrangeShadow" ref={Loadref} id="loadFlight" onClick={() => loadFlightData()} disabled = {isLoadFlightAvailable}><span class="px-4">Load</span></button>
                    {/* disabled={selectedRow === -1} */}
                </div>
                </FocusLock>
                </div>
            </div>
        </div>
    </div>
    );
}
export default FlightSearch;